import { Injectable } from '@angular/core';
import { BackendService } from 'app/core/backend.service';
import { forkJoin, Observable, of, Subject } from 'rxjs';
import { ExtendedTreeNode } from '../../shared/dynamic-details-tree/extended-tree-node.model';
import { ObjectDrawerFilter } from './object-drawer-filter/object-drawer-filter';

@Injectable({
  providedIn: 'root',
})
export class ObjectDrawerService {
  public itemSelected = new Subject<any>();
  public toggleDrawer = new Subject();
  public toggleView = new Subject();
  public loadMoreClicked = new Subject();
  public treeNodeExpanded = new Subject<ExtendedTreeNode>();
  public search = new Subject<string>();
  public filtersApplied = new Subject();
  public selectedTreeNode: ExtendedTreeNode;
  public appliedFilters: ObjectDrawerFilter[] = [];
  public newTreeItemName = new Subject<string>();

  constructor(private backendService: BackendService) {}

  public addFilter(filter: ObjectDrawerFilter): void {
    const alreadyAdded = this.appliedFilters.find(e => e.propertyName === filter.propertyName);
    if (alreadyAdded && this.appliedFilters.includes(alreadyAdded)) {
      this.appliedFilters[this.appliedFilters.indexOf(alreadyAdded)] = filter;
    } else {
      this.appliedFilters.push(filter);
    }
  }

  public removeFilter(filter: ObjectDrawerFilter): void {
    const itemIndex = this.appliedFilters.indexOf(filter);
    if (itemIndex > -1) {
      this.appliedFilters.splice(itemIndex, 1);
    }
  }

  public getFilterOptionsObservables(availableFilters: ObjectDrawerFilter[]): any {
    const observables = {};
    if (availableFilters && availableFilters.length > 0) {
      const filtersForLazyLoad = availableFilters.filter(e => e.lazyLoad && e.lazyLoadEndpoint);
      filtersForLazyLoad.forEach(e => {
        const observable = this.getObjectDrawerFilterOptions(e.lazyLoadEndpoint);
        observables[e.propertyName] = observable;
      });
    }
    return observables;
  }

  public getLazyLoadFilterOptions(observables: any): Observable<any> {
    if (observables && Object.keys(observables).length > 0) {
      return forkJoin(observables);
    } else {
      return of({});
    }
  }

  private getObjectDrawerFilterOptions(apiRoute: string): Observable<any> {
    return this.backendService.getAnyById(apiRoute, '');
  }

  public resetAppliedFilters(): void {
    if (this.appliedFilters && this.appliedFilters.length > 0) {
      this.appliedFilters = [];
    }
  }
}
